import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TemplateCard = ({ template, onSelect, onPreview }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div
      className="bg-card rounded-xl border border-border overflow-hidden transition-all duration-300 hover:shadow-elevation-3"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-muted">
        <Image
          src={template?.thumbnail}
          alt={template?.thumbnailAlt}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        />
        
        {isHovered && (
          <div className="absolute inset-0 bg-background/90 flex items-center justify-center gap-3 animate-in fade-in duration-200">
            <Button
              variant="secondary"
              size="sm"
              iconName="Eye"
              iconPosition="left"
              onClick={() => onPreview(template)}
            >
              Предпросмотр
            </Button>
            <Button
              variant="default"
              size="sm"
              iconName="Check"
              iconPosition="left"
              onClick={() => onSelect(template)}
            >
              Выбрать
            </Button>
          </div>
        )}

        {template?.isFeatured && (
          <div className="absolute top-3 right-3 bg-accent text-accent-foreground px-3 py-1 rounded-full caption font-medium flex items-center gap-1">
            <Icon name="Star" size={14} />
            Популярный
          </div>
        )}

        {template?.hasBookingWidget && (
          <div className="absolute top-3 left-3 bg-success text-success-foreground px-3 py-1 rounded-full caption font-medium flex items-center gap-1">
            <Icon name="Calendar" size={14} />
            Виджет бронирования
          </div>
        )}
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-base md:text-lg text-foreground mb-1 truncate">
              {template?.name}
            </h3>
            <p className="caption text-text-secondary flex items-center gap-1">
              <Icon name="Tag" size={14} />
              {template?.category}
            </p>
          </div>
        </div>

        <p className="text-sm text-text-secondary mb-4 line-clamp-2">
          {template?.description}
        </p>

        <div className="flex flex-wrap gap-2 mb-4">
          {template?.features?.slice(0, 3)?.map((feature, index) => (
            <span
              key={index}
              className="caption bg-muted text-text-secondary px-2 py-1 rounded"
            >
              {feature}
            </span>
          ))}
        </div>

        <Button
          variant="outline"
          fullWidth
          iconName="ArrowRight"
          iconPosition="right"
          onClick={() => onSelect(template)}
        >
          Выбрать шаблон
        </Button>
      </div>
    </div>
  );
};

export default TemplateCard;